import { Injectable } from '@angular/core';
import { DialogParams, DialogResult, DialogTypes } from 'src/app/shared/dialog-modal/dialog-types';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})

export class DialogModalService {
    public source: BehaviorSubject<DialogParams> = new BehaviorSubject<DialogParams>(new DialogParams(
        null, null, null, null, null, null, null, null, null));
    modalSubject = this.source.asObservable();
    dialogResult: Subscriber<DialogResult> = new Subscriber<DialogResult>();

    constructor(
        private translate: TranslateService
    ) { }

    openSuccessModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_INFO');
        }
        return this.openModal(DialogTypes.success, title, message, null, null, null, colorDialog);
    }

    openErrorModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_ERROR');
        }
        return this.openModal(DialogTypes.error, title, message, this.translate.instant('STR_BTN_OK'), null, null, colorDialog);
    }

    openWarningModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_WARNING');
        }
        return this.openModal(DialogTypes.warning, title, message, this.translate.instant('STR_BTN_OK'), null, null, colorDialog);
    }

    openInfoModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_INFO');
        }
        return this.openModal(DialogTypes.info, title, message, this.translate.instant('STR_BTN_OK'), null, null, colorDialog);
    }

    openConfirmModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_CONFIRMATION');
        }
        return this.openModal(DialogTypes.confirm, title, message,
            this.translate.instant('STR_BTN_OK'), null, this.translate.instant('STR_BTN_CANCEL'), colorDialog);
    }

    openVerificationModal(message: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_CONFIRMATION');
        }
        return this.openModal(DialogTypes.confirm, title, message,
            this.translate.instant('STR_BTN_YES'), this.translate.instant('STR_BTN_NO'),
            this.translate.instant('STR_BTN_CANCEL'), colorDialog);
    }

    openCheckboxModal(message: string, lbCheck?: string, title?: string, colorDialog?: string): Observable<DialogResult> {
        if (!title) {
            title = this.translate.instant('STR_MODAL_WARNING');
        }
        return this.openModal(DialogTypes.confirm, title, message, null, null, null, colorDialog, lbCheck, this.translate.instant('STR_BTN_YES'));
    }

    openModal(type: string, title: string, message: string, okBtn: string, noBtn: string, cancelBtn: string, colorDialog: string,
              checklabel = '', checkBtn = ''): Observable<DialogResult> {
        this.source.next(new DialogParams(type, title, message, okBtn, noBtn, cancelBtn, colorDialog, checklabel, checkBtn));
        return new Observable<DialogResult>(subscriber => {
            this.dialogResult = subscriber;
        });
    }

}
